<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4">Atualizar Grupo de Expressões - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroRegex edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import regexsStore from '../_store'

import CadastroRegex from './CadastroRegex'

export default {
  name: 'AtualizarRegex',
  props: {
    _id: String,
  },
  components: { CadastroRegex, SkeletonLoaderTitleUpdate },

  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarRegexModulePABXStore', ['getRegex']),
  },

  async created() {
    this.showSkeleton = true
    registerVuexModule(this.$store, 'atualizarRegexModulePABXStore', regexsStore)

    await this.listarUmaRegex(this._id)
    this.description = this.getRegex.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarRegexModulePABXStore', ['listarUmaRegex']),
  },
}
</script>
